export default __webpack_public_path__ + "static/service-shape-200a563c8f78b68c5fe1d7fbd875c881.png";